(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6869],{

/***/ 67568:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/faq/[slug]",
      function () {
        return __webpack_require__(62228);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 62228:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ FrequentlyAskedQuestion; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./components/Link/index.ts + 1 modules
var Link = __webpack_require__(504);
// EXTERNAL MODULE: ./components/PortableText/index.ts + 2 modules
var PortableText = __webpack_require__(44904);
// EXTERNAL MODULE: ./components/page-sections/Intro/index.ts + 1 modules
var Intro = __webpack_require__(47849);
// EXTERNAL MODULE: ./components/page-sections/CallToAction/index.ts + 1 modules
var CallToAction = __webpack_require__(31437);
// EXTERNAL MODULE: ./components/page-sections/MedicallyReviewedBy/MedicallyReviewedBy.tsx
var MedicallyReviewedBy = __webpack_require__(88542);
;// CONCATENATED MODULE: ./components/page-sections/MedicallyReviewedBy/index.ts


;// CONCATENATED MODULE: ./pages/faq/[slug].tsx







var __N_SSG = true;
function FrequentlyAskedQuestion(param) {
    var frequentlyAskedQuestion = param.frequentlyAskedQuestion;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: frequentlyAskedQuestion.metaTitle || "".concat(frequentlyAskedQuestion.question, " | Dawn Health")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: frequentlyAskedQuestion.description || "Frequently asked question we often get about sleep."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "viewport",
                        content: "initial-scale=1.0, width=device-width"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                className: "text-dawnDark-500",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Intro/* IntroBase */.O, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                            className: "flex justify-center pt-6 text-white pb-22 md:py-30",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                className: "md:text-5xl text-2.5xl leading-8 md:leading-14 font-semibold text-center",
                                children: frequentlyAskedQuestion.question
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex justify-center px-6 py-20 md:py-30",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "max-w-1.5xl",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "prose lg:prose-lg xl:prose-xl font-inter",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PortableText/* PortableText */.Y, {
                                        blocks: frequentlyAskedQuestion.answer
                                    })
                                }),
                                frequentlyAskedQuestion.medicallyReviewedBy && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MedicallyReviewedBy/* MedicallyReviewedBy */.$, {
                                        teamMember: frequentlyAskedQuestion.medicallyReviewedBy
                                    })
                                }),
                                frequentlyAskedQuestion.relatedQuestions && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "mt-10 md:mt-14 font-inter",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "text-2xl font-semibold md:text-4xl",
                                            children: "Related questions"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "mt-4 space-y-4",
                                            children: [
                                                frequentlyAskedQuestion.relatedQuestions.map(function(question) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                                                        href: "/faq/".concat(question.slug.current),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            className: "block md:text-xl md:leading-8",
                                                            children: question.question
                                                        })
                                                    }, question._id);
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                                                    href: "/faq/category/".concat(frequentlyAskedQuestion.category.slug.current),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        className: "block md:text-xl md:leading-8 text-dawnPurple-500",
                                                        children: "View all"
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CallToAction/* CallToAction */.J, {
                        title: "Cure your insomnia today.",
                        text: "Craving good sleep? Talk to a sleep coach and find out more about Dawn\u2019s program for curing sleep problems"
                    })
                ]
            })
        ]
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3662,9122,5329,5430,1421,1310,2595,1437,2232,9928,9774,2888,179], function() { return __webpack_exec__(67568); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);